export default __webpack_public_path__ + "static/media/WebIcon.73a4cc63.svg";